export type CalendarDayRequestToken = {
    generation: number;
    kind: "initial" | "loadMore";
};

export type CalendarDayRequestGuard = {
    finish: (token: CalendarDayRequestToken) => void;
    invalidate: () => void;
    isCurrent: (token: CalendarDayRequestToken) => boolean;
    startInitial: () => CalendarDayRequestToken;
    startLoadMore: () => CalendarDayRequestToken | null;
};

export function createCalendarDayRequestGuard(): CalendarDayRequestGuard {
    let generation = 0;
    let loadMoreInFlight = false;

    return {
        finish: (token) => {
            if (token.generation === generation && token.kind === "loadMore") {
                loadMoreInFlight = false;
            }
        },
        invalidate: () => {
            generation += 1;
            loadMoreInFlight = false;
        },
        isCurrent: (token) => token.generation === generation,
        startInitial: () => {
            generation += 1;
            loadMoreInFlight = false;
            return {generation, kind: "initial"};
        },
        startLoadMore: () => {
            if (loadMoreInFlight === true) return null;
            loadMoreInFlight = true;
            return {generation, kind: "loadMore"};
        },
    };
}
